import { type FC, useCallback } from 'react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'

interface Props {
  className?: string
}

export const AddTierDialogButton: FC<Props> = ({ className }) => {
  const handleDialogOpen = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.TIERS_DIALOG,
      testId: 'add-list-dialog',
    })
  }, [])

  return (
    <Button
      onClick={handleDialogOpen}
      className={className}
      testId="add-list-button"
    >
      <span className="mr-1">
        <PlusIcon />
      </span>
      Add List
    </Button>
  )
}
